import {Dialog, DialogContent, IconButton} from '@mui/material';
import {experimentalStyled as styled} from '@mui/material/styles';
import {Close as CloseIcon} from '@mui/icons-material';
import {useState} from 'react';

const ProductImgStyle = styled('img')({
	width: 50,
	height: 50,
	objectFit: 'cover',
	cursor: 'pointer',
	borderRadius: 4,
	transition: 'transform 0.2s ease-in-out',
	'&:hover': {
		transform: 'scale(1.05)',
	},
});

const ImageDialog = styled(Dialog)(({theme}) => ({
	'& .MuiDialog-paper': {
		margin: theme.spacing(1),
		maxWidth: '95vw',
		maxHeight: '95vh',
		backgroundColor: 'rgba(0, 0, 0, 0.9)',
	},
}));

const FullSizeImage = styled('img')({
	width: '100%',
	height: 'auto',
	maxWidth: '90vw',
	maxHeight: '80vh',
	objectFit: 'contain',
	borderRadius: 8,
});

export const CloseButton = styled(IconButton)(({theme}) => ({
	position: 'absolute',
	top: theme.spacing(1),
	right: theme.spacing(1),
	color: 'white',
	backgroundColor: 'rgba(0, 0, 0, 0.5)',
	'&:hover': {
		backgroundColor: 'rgba(0, 0, 0, 0.7)',
	},
}));

export function ProductImagePreview({src, alt, size = 50, ...props}) {
	const [imageDialogOpen, setImageDialogOpen] = useState(false);

	const handleImageClick = (e) => {
		e.preventDefault();
		e.stopPropagation();
		setImageDialogOpen(true);
	};

	const handleCloseDialog = () => {
		setImageDialogOpen(false);
	};

	return (
		<>
			<ProductImgStyle
				src={src}
				onClick={handleImageClick}
				alt={alt}
				sx={{
					width: size,
					height: size,
				}}
				{...props}
			/>

			{/* Image Preview Dialog */}
			<ImageDialog
				open={imageDialogOpen}
				onClose={handleCloseDialog}
				maxWidth={false}
				PaperProps={{
					style: {
						backgroundColor: 'transparent',
						boxShadow: 'none',
					},
				}}
			>
				<DialogContent
					sx={{
						padding: 0,
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						position: 'relative',
					}}
				>
					<CloseButton onClick={handleCloseDialog} size="small">
						<CloseIcon />
					</CloseButton>
					<FullSizeImage src={src} alt={alt} onClick={handleCloseDialog} />
				</DialogContent>
			</ImageDialog>
		</>
	);
}

export default ProductImagePreview;
